import { EmployeeWithBuFragment } from '../../../../../integration-tests/common/types'

export const sortEmployeesWithBusByName = (employeeData: EmployeeWithBuFragment[]): EmployeeWithBuFragment[] => {
  return [...employeeData].sort((a, b) => {
    const nameCompare = a.firstName.localeCompare(b.firstName)
    if (nameCompare !== 0) {
      return nameCompare
    } else {
      return a.lastName.localeCompare(b.lastName)
    }
  })
}
